import React, {Component} from "react";

import LoaderButton from "../components/LoaderButton";
import { Auth, API } from "aws-amplify";
import Confirmation from "./Confirmation";
import "./RetnetRegister.css"

export default class RetnetRegister extends Component {
  constructor(props){
    super(props);
    this.paynow = React.createRef();

    this.state = {


    };
  }

  validateForm() {

  }

  getErrorElement(){
     return this.state.errorMsg && this.state.errorMsg.length > 0
                             ? <div className="alert alert-danger" role="alert">
                                 {this.state.errorMsg}
                               </div>
                             : "";
  }


  render(){
    return(
     <div class="container-fluid">


          <div className="row" hidden>

              <div className="col-md-8">

                  <div className="container d-flex">
                      <div className="row cols-xs-space cols-sm-space text-center">

                          <div className="col-12 col-lg-10 holder-item-light">
                              <img className="retnet-banner" src="/images/RETNETFlyer1.JPG" height="500px" />


                            <a href="https://form.jotform.com/200200565419445" className="btn btn-success text-uppercase btn-circle retnet-btn" >
                                           SUBMIT YOUR PRESENTATION
                                </a>
                                <a href="/register4retnet" className="btn btn-success text-uppercase btn-circle retnet-btn">
                                              REGISTER FOR RETNET-2024
                               </a>
                        </div>

                      </div>


                  </div>
              </div>
              <div className="col-md-4">

                  <img className="retnet-banner" src="/images/preconferenceworkshop2.png" />

              </div>


          </div>



          {/*<div className="text-center retnet-highlight-text">*/}
          {/*    <br />*/}
          {/*    <h3 className="retnet2020title"> 14<sup>th</sup> Retnet Conference </h3>*/}
          {/*    <h3 className="retnet2020title"> Clarks Exotica- Convention Resorts & Spa </h3>*/}
          {/*    <h4 className="retnet2020title"> 8<sup>th</sup> & 9<sup>th</sup> June 2024 </h4>*/}

          {/*    /!*<h6 className="retnet2020title"> EARLY BIRD REGISTRATIONS OPEN </h6>*!/*/}

          {/*   <h6 className="retnet2020title">REGISTER NOW</h6>*/}
          {/*    <br />*/}


          {/*</div>*/}

          <div className="row">
              <div className="col-md-12">
                    {/*<div className="row">*/}

                    {/*    /!*<div className="card  retnet-price-box left200margin">*!/*/}
                    {/*    /!*    <div className="card-body retnet-center-text">*!/*/}
                    {/*    /!*        <h5 className="heading heading-5 strong-600 retnet-center-text">Watch Retnet Live <br/> <br/> <br /></h5>*!/*/}
                    {/*    /!*        <h3 className="price-tag retnet-center-text retnet-no-padding">&#x20B9;3,000</h3>*!/*/}
                    {/*    /!*        <h6 className="retnet-center-text">per person</h6> <br/>*!/*/}

                    {/*    /!*        <a className="btn btn-success" href="/retnetlive">Get Zoom Link</a>*!/*/}

                    {/*    /!*    </div>*!/*/}
                    {/*    /!*    Charges Includes:*!/*/}
                    {/*    /!*    <ul >*!/*/}
                    {/*    /!*        <li>Retnet 2022 Live Zoom Link</li>*!/*/}
                    {/*    /!*        <br/>*!/*/}
                    {/*    /!*        <br/>*!/*/}
                    {/*    /!*        <br/>*!/*/}
                    {/*    /!*        <br/>*!/*/}


                    {/*    /!*    </ul>*!/*/}
                    {/*    /!*</div>*!/*/}

                    {/*    /!*<div className="card  retnet-price-box ">*!/*/}
                    {/*    /!*    <div className="card-body retnet-center-text">*!/*/}
                    {/*    /!*        <h5 className="heading heading-5 strong-600 retnet-center-text">Retnet 2023 Live Streaming*!/*/}
                    {/*    /!*            <br/> <br/> <br /> <br />*!/*/}
                    {/*    /!*        </h5>*!/*/}
                    {/*    /!*        <h3 className="price-tag retnet-center-text retnet-no-padding">&#x20B9;1,000</h3>*!/*/}
                    {/*    /!*        <h6 className="retnet-center-text">per person</h6> <br/>*!/*/}

                    {/*    /!*        <a className="btn btn-success" href="/retnetlive">Register Now</a>*!/*/}

                    {/*    /!*    </div>*!/*/}
                    {/*    /!*    Charges Includes:*!/*/}
                    {/*    /!*    <ul >*!/*/}
                    {/*    /!*        <li>Zoom Link for Retnet 2023</li>*!/*/}
                    {/*    /!*        <br/>*!/*/}
                    {/*    /!*        <br/>*!/*/}
                    {/*    /!*        <br/>*!/*/}
                    {/*    /!*        <br/>*!/*/}


                    {/*    /!*    </ul>*!/*/}
                    {/*    /!*</div>*!/*/}

                    {/*    /!*<div className="card  retnet-price-box ">*!/*/}
                    {/*    /!*    <div className="card-body retnet-center-text">*!/*/}
                    {/*    /!*        <h5 className="heading heading-5 strong-600 retnet-center-text">Pre-Conference Workshop only*!/*/}
                    {/*    /!*            <br/> <br/> <br /> <br />*!/*/}
                    {/*    /!*        </h5>*!/*/}
                    {/*    /!*        <h3 className="price-tag retnet-center-text retnet-no-padding">&#x20B9;500</h3>*!/*/}
                    {/*    /!*        <h6 className="retnet-center-text">per person</h6> <br/>*!/*/}

                    {/*    /!*        <a className="btn btn-success" href="/preconference">Register Now</a>*!/*/}

                    {/*    /!*    </div>*!/*/}
                    {/*    /!*    Charges Includes:*!/*/}
                    {/*    /!*    <ul >*!/*/}
                    {/*    /!*        <li>Pre-Conference Workshop Registration</li>*!/*/}
                    {/*    /!*        <li>On 22nd July 2023 10 AM to 1 PM</li>*!/*/}
                    {/*    /!*        <li>Breakfast Included </li>*!/*/}
                    {/*    /!*        <br/>*!/*/}
                    {/*    /!*        <br/>*!/*/}


                    {/*    /!*    </ul>*!/*/}
                    {/*    /!*</div>*!/*/}

                    {/*    <div className="card  retnet-price-box ">*/}
                    {/*        <div className="card-body retnet-center-text">*/}
                    {/*            <h5 className="heading heading-5 strong-600 retnet-center-text">Retnet India Conference only*/}
                    {/*                <br/> <br/> <br /> <br />*/}
                    {/*            </h5>*/}
                    {/*            <h3 className="price-tag retnet-center-text retnet-no-padding">&#x20B9;6,750</h3>*/}
                    {/*            <h6 className="retnet-center-text">per person</h6> <br/>*/}

                    {/*            <a className="btn btn-success" href="/conference">Register Now</a>*/}

                    {/*        </div>*/}
                    {/*        Charges Includes:*/}
                    {/*        <ul >*/}
                    {/*            <li>Conference Registration</li>*/}
                    {/*            <li>June 8th - Lunch & Dinner</li>*/}
                    {/*            <li>June 9th - Breakfast & Lunch</li>*/}
                    {/*            <br/>*/}
                    {/*            <br/>*/}

                    {/*        </ul>*/}
                    {/*    </div>*/}

                    {/*    <div className="card  retnet-price-box ">*/}
                    {/*        <div className="card-body retnet-center-text">*/}
                    {/*            <h5 className="heading heading-5 strong-600 retnet-center-text">Retnet India Conference*/}
                    {/*                <br/> + <br/> Single Occupancy Room*/}
                    {/*                <br/> 1 Day*/}
                    {/*            </h5>*/}
                    {/*            <h3 className="price-tag retnet-center-text retnet-no-padding">&#x20B9;12,000</h3>*/}
                    {/*            <h6 className="retnet-center-text">per person</h6> <br/>*/}
                    {/*            <a className="btn btn-success" href="/singleroom">Register Now</a>*/}


                    {/*        </div>*/}
                    {/*        Charges Includes:*/}
                    {/*        <ul >*/}
                    {/*            <li>Conference Registration</li>*/}
                    {/*            <li>Hotel Check in June 8th at 3pm</li>*/}
                    {/*            <li>Hotel Check out June 9th by 12pm </li>*/}
                    {/*            <li>June 8th - Lunch & Dinner</li>*/}
                    {/*            <li>June 9th - Breakfast & Lunch</li>*/}

                    {/*        </ul>*/}
                    {/*    </div>*/}

                    {/*    <div className="card  retnet-price-box ">*/}
                    {/*        <div className="card-body retnet-center-text">*/}
                    {/*            <h5 className="heading heading-5 strong-600 retnet-center-text">Retnet India Conference*/}
                    {/*                <br /> + <br/> Double Occupancy Room*/}
                    {/*                <br/> 1 Day*/}
                    {/*            </h5>*/}
                    {/*            <h3 className="price-tag retnet-center-text retnet-no-padding">&#x20B9;8,500</h3>*/}
                    {/*            <h6 className="retnet-center-text">per person</h6> <br/>*/}
                    {/*            <a className="btn btn-success" href="/doubleroom">Register Now</a>*/}


                    {/*        </div>*/}
                    {/*        Charges Includes:*/}
                    {/*        <ul >*/}
                    {/*            <li>Conference Registration</li>*/}
                    {/*            <li>Hotel Check in June 8th at 3pm</li>*/}
                    {/*            <li>Hotel Check out June 9th by 12pm </li>*/}
                    {/*            <li>June 8th - Lunch & Dinner</li>*/}
                    {/*            <li>June 9th - Breakfast & Lunch</li>*/}

                    {/*        </ul>*/}
                    {/*    </div>*/}

                    {/*</div>*/}


                    {/*<br />*/}

                    {/*<div className="row">*/}


                    {/*    <div className="card  retnet-price-box ">*/}
                    {/*        <div className="card-body retnet-center-text">*/}
                    {/*            <h5 className="heading heading-5 strong-600 retnet-center-text">Retnet India Conference*/}
                    {/*                <br /> + <br/> Single Occupancy Room*/}
                    {/*                <br/> Previous Night*/}
                    {/*            </h5>*/}
                    {/*            <h3 className="price-tag retnet-center-text retnet-no-padding">&#x20B9;10,000</h3>*/}
                    {/*            <h6 className="retnet-center-text">per person</h6> <br/>*/}
                    {/*            <a className="btn btn-success" href="/singleroom2nights">Register Now</a>*/}


                    {/*        </div>*/}
                    {/*        Charges Includes:*/}
                    {/*        <ul >*/}
                    {/*            <li>Conference Registration</li>*/}
                    {/*            <li>Hotel Check in June 7th at 3pm</li>*/}
                    {/*            <li>Hotel Check out June 8th by 12pm </li>*/}
                    {/*            <li>June 7th - Dinner</li>*/}
                    {/*            <li>June 8th - Breakfast</li>*/}

                    {/*        </ul>*/}
                    {/*    </div>*/}

                    {/*    <div className="card  retnet-price-box ">*/}
                    {/*        <div className="card-body retnet-center-text">*/}
                    {/*            <h5 className="heading heading-5 strong-600 retnet-center-text">Retnet India Conference*/}
                    {/*                <br /> + <br/> Double Occupancy Room*/}
                    {/*                <br/> Previous Night*/}
                    {/*            </h5>*/}
                    {/*            <h3 className="price-tag retnet-center-text retnet-no-padding">&#x20B9;6,500</h3>*/}
                    {/*            <h6 className="retnet-center-text">per person</h6> <br/>*/}
                    {/*            <a className="btn btn-success" href="/doubleroom2nights">Register Now</a>*/}


                    {/*        </div>*/}
                    {/*        Charges Includes:*/}
                    {/*        <ul >*/}
                    {/*            <li>Conference Registration</li>*/}
                    {/*            <li>Hotel Check in June 7th at 3pm</li>*/}
                    {/*            <li>Hotel Check out June 8th by 12pm </li>*/}
                    {/*            <li>June 7th - Dinner</li>*/}
                    {/*            <li>June 8th - Breakfast</li>*/}

                    {/*        </ul>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <br />
                    <div className="row">
                        <div className="col-md-4">
                        </div>
                        <div className="col-md-4">
                            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfOQepPchjPa7IyRIK74-dV45cQE56krjvEG4rJGtWyoFbptA/viewform"
                               target="_blank" className="btn btn-success text-uppercase btn-circle retnet-btn text" >
                                Register For Retnet
                            </a>
                        </div>
                        <div className="col-md-4">
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-2">

                        </div>
                        <div className="col-md-8">

                            <img  src="/images/retnet2025-payment.jpeg" height="1100px" width="100%" />

                        </div>
                        <div className="col-md-2">

                        </div>


                    </div>



              </div>

              {/*<div className="col-md-4">*/}
              {/*    <br />*/}
              {/*    <h2 className="retnet-center-text blink_me"> Retnet Conference Venue </h2>*/}
              {/*    <div className="retnet-center-text retnet2020title"><b>Sheraton Grand Bangalore Hotel</b></div>*/}
              {/*    <div className="retnet-center-text retnet2020title"><b>RAJAJINAGAR</b></div>*/}
              {/*    <div className="retnet-center-text retnet2020title">Bengaluru, Karnataka</div>*/}


              {/*    <img src="/images/sheraton_hotel_pic.png" className="venue-img"  />*/}

              {/*    <br />*/}

              {/*    <div className="retnet-center-text retnet2020title"><b>Travel Time 60 to 90 mins </b></div>*/}
              {/*    <div className="retnet-center-text"><b>From KIA Airport to Venue </b></div>*/}
              {/*    <iframe className="retnet-center-text" className="venue-map"*/}
              {/*                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d18173.*/}
              {/*                  82442207325!2d77.55496487475!3d13.01281988515256!3m2!1i1024*/}
              {/*                  !2i768!4f13.1!3m3!1m2!1s0x0%3A0x6832860dbb5cd434!2sSheraton%2*/}
              {/*                  0Grand%20Bangalore%20Hotel%20at%20Brigade%20Gateway!5e0!3m2!*/}
              {/*                  1sen!2sin!4v1582802686940!5m2!1sen!2sin">*/}
              {/*    </iframe>*/}

              {/*</div>*/}

          </div>


          <br />
          <br />
      </div>



    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/RetnetRegister2020.js